module.exports = require('./src').locale2()



//////////////////
// WEBPACK FOOTER
// ./node_modules/locale2/index.js
// module id = 972
// module chunks = 0